import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { map } from 'rxjs/operators';
import { DialogService } from '../../app/services/dialog.service';
import { Permission } from '../auth/account.model';
import { PermissionService } from '../services/permission.service';
import { PlatformService } from '../services/platform.service';
import { DIALOG_SERVICE } from './login.guard';

/**
 * 권한 가드
 */
export const permissionGuard = (
  ...permissionList: Permission[]
): CanActivateFn => {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router = inject(Router);
    const permissionService = inject(PermissionService);
    const dialogServiceType = inject(DIALOG_SERVICE);
    const dialogService: DialogService = inject(dialogServiceType);
    const platformService = inject(PlatformService);

    // 서버는 무조건 통과
    if (platformService.isPlatformServer) {
      return true;
    }

    // 권한 제한 없으면 무조건 통과
    if (!permissionList?.length) {
      return true;
    }

    // 권한 있는 사용자면 통과
    if (permissionService.isAvail(...permissionList)) {
      return true;
    }

    // 이 시점에는 번역 불가하므로 영어로 권한 없음 안내
    return dialogService.alert('No permission').pipe(
      map(() => {
        // 홈으로 이동
        return router.createUrlTree(['/home']);
      }),
    );
  };
};
